import * as types from '../../mutation-types'

// initial state

const state = {
  historyTopic: {}
}

// getters
const getters = {
  historyTopic: state => state.historyTopic
}

// actions
const actions = {

}

// mutations
const mutations = {
  [types.SET_HISTORY_TOPIC] (state, historyToipc) {
    state.historyTopic = historyToipc
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/topic-manage/topic-manage.js